// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'jquery-smarttab/dist/js/jquery.smartTab.min.js';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

var read_more_height = 500;

function checkReadMoreHeight() {
	var overflow = jQuery('.read_more__overflow');

	if (overflow.height() > read_more_height) {
		overflow[0].setAttribute('data-collapsed', 'true');
		overflow.height(read_more_height + 'px');
		overflow.parent().addClass('read_more--truncated read_more--collapsed');
	}
}

function debounce(func, wait, immediate) {
	var timeout;

	return function executedFunction() {
		var context = this;
		var args = arguments;

		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};

		var callNow = immediate && !timeout;

		clearTimeout(timeout);

		timeout = setTimeout(later, wait);

		if (callNow) func.apply(context, args);
	};
};

// Product Single
if (jQuery('.read_more__overflow').length > 0) {
	checkReadMoreHeight();
}

if (jQuery('.wpcf7-form-control-wrap.sector').length > 0) {
	jQuery('.wpcf7-form-control-wrap.sector select option')[0].text = 'Sector*';
}

jQuery(window).on('load', function() {
	jQuery('html').removeClass('preload');

	jQuery('.read_more__button').click(function() {
		var overflow_cont = jQuery('.read_more__overflow')[0];
		var isCollapsed = overflow_cont.getAttribute('data-collapsed') === 'true';

		if(isCollapsed) {
			expandSection(overflow_cont)
			overflow_cont.setAttribute('data-collapsed', 'false');
			jQuery('.read_more').removeClass('read_more--collapsed');
			jQuery('.read_more').addClass('read_more--expanded');
		} else {
			collapseSection(overflow_cont);
			jQuery('.read_more').addClass('read_more--collapsed');
			jQuery('.read_more').removeClass('read_more--expanded');
		}
	});


	// This is the important part!

	function collapseSection(element) {
		// get the height of the element's inner content, regardless of its actual size
		var sectionHeight = element.scrollHeight;

		// temporarily disable all css transitions
		var elementTransition = element.style.transition;
		element.style.transition = '';

		// on the next frame (as soon as the previous style change has taken effect),
		// explicitly set the element's height to its current pixel height, so we
		// aren't transitioning out of 'auto'
		requestAnimationFrame(function() {
			element.style.height = sectionHeight + 'px';
			element.style.transition = elementTransition;

			// on the next frame (as soon as the previous style change has taken effect),
			// have the element transition to height: 0
			requestAnimationFrame(function() {
				element.style.height = read_more_height + 'px';
			});
		});

		// mark the section as "currently collapsed"
		element.setAttribute('data-collapsed', 'true');
	}

	function expandSection(element) {
		// get the height of the element's inner content, regardless of its actual size
		var sectionHeight = element.scrollHeight;

		// have the element transition to the height of its inner content
		element.style.height = sectionHeight + 'px';

		// when the next css transition finishes (which should be the one we just triggered)
		var foo = function(e) {
			element.removeEventListener('transitionend', foo, false);

			// remove "height" from the element's inline styles, so it can return to its initial value
			element.style.height = null;
		}
		element.addEventListener('transitionend', foo);

		// mark the section as "currently not collapsed"
		element.setAttribute('data-collapsed', 'false');
	}


});

jQuery(document).ready(function() {

	//Print order
	jQuery('#order-print-button').click(function (e) {
		e.preventDefault();
		window.print();
	});

	jQuery('.desktop_menu a.search, .resi_search').click(function (e){
		e.preventDefault();
		jQuery('.search-wrap').removeClass('hidden');
		jQuery("#desk-search-input").focus().val('');
	});

	jQuery('.search-wrap .close').click(function (e){
		jQuery('.search-wrap').addClass('hidden');
	});

	jQuery(".star-rating").click(function() {

		jQuery("#tab-title-reviews a").trigger("click");

		jQuery('html, body').animate({
			scrollTop: jQuery(".tabs").offset().top
		}, 2000);

	});

	// if ( jQuery(window).width() < 600) {
	//  jQuery('div.product-slider').addClass('swiper-container');
	//  jQuery('div.product-wrapper').addClass('swiper-wrapper');
	// }

	var productSwiperThree = new Swiper('.product-slider__three', {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 400,
		pagination: {
			type: 'bullets',
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			600: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
		}
	});

	var productSwiperTwo = new Swiper('.product-slider__two', {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 400,
		pagination: {
			type: 'bullets',
			el: '.swiper-pagination',
			clickable: true,
		},
		breakpoints: {
			600: {
				slidesPerView: 2,
			},
		}
	});

	var gallery_options = {
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		slidesPerView: 1,
		spaceBetween: 13,
		centeredSlides: true,
		loop: true,
		speed: 400,
		longSwipes: false,
		slideToClickedSlide: true,
		breakpoints: {
			600: {
				slidesPerView: 2,
				spaceBetween: 52,
				autoplay: {
					delay: 3000,
					disableOnInteraction: false,
				},
			},
		},
		navigation: {
			nextEl: '.sliding-gallery__hardwood .swiper-button-next',
			prevEl: '.sliding-gallery__hardwood .swiper-button-prev'
		}
	}

	if (jQuery('.sliding-gallery__hardwood').length > 0) {
		var hardwood_swiper = new Swiper('.sliding-gallery__hardwood .swiper-container', gallery_options);
	}

	if (jQuery('.sliding-gallery__storage').length > 0) {
		gallery_options.navigation.nextEl = '.sliding-gallery__storage .swiper-button-next';
		gallery_options.navigation.prevEl = '.sliding-gallery__storage .swiper-button-prev';
		var storage_swiper = new Swiper('.sliding-gallery__storage .swiper-container', gallery_options);
	}

	// var gallerySwiperMob = new Swiper('.gallery-slider__mobile.swiper-container', {
	// 	slidesPerView: 2,
	// 	spaceBetween: 20,
	// 	centeredSlides: true,
	// 	loop: true,
	// 	speed: 400,
	// 	longSwipes: false,
	// });

	var flexiSwiper = new Swiper('.flexi__swiper__slider', {
		slidesPerView: 1,
		spaceBetween: 13,
		centeredSlides: true,
		loop: true,
		speed: 400,
		longSwipes: false,
		breakpoints: {
			600: {
				slidesPerView: 2.5,
				spaceBetween: 30,
			},
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
			renderFraction: function (currentClass, totalClass) {
				return 'Image <span class="' + currentClass + '"></span>' +
				' of ' +
				'<span class="' + totalClass + '"></span>';
			}
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});

	jQuery('#delivery-tabs').smartTab({
		transition: {
			animation: 'fade',
			speed: '300'
		},
		autoAdjustHeight: false,
		enableURLhash: false
	});

	var width = jQuery(window).width();

	function resiNav() {
		jQuery( ".menu" ).before( "<figure></figure>" );
		jQuery('.sub-menu').prepend('<li class="current_parent"><p></p></li>');

		var parents = jQuery('.menu-item-has-children');
		for (var i = 0; i < parents.length; i++) {
			var parentTitle = parents[i].children[0].text;
			var previousParentTitle = parents[i].children[1].children[0].children[0];
			previousParentTitle.innerText = parentTitle;
		}

		jQuery('.menu-header .menu-item-has-children > a').click(function (e) {
			// if (jQuery(window).width() < 920) {
			// 	e.preventDefault();
			// }
			// jQuery(this).parent().toggleClass('open');
			jQuery(this).next('ul.sub-menu').toggleClass('open');
		});

		jQuery('li.current_parent').click(function() {
			jQuery(this).parent().toggleClass('open');
		});

		jQuery('.resi_button, .resi_over, .menu-header figure').click(function() {
			jQuery('html').toggleClass('js-nav');
			jQuery('ul.sub-menu').removeClass('open')
		});

	}
	resiNav();

	jQuery('*[data-scroll]').click(function() {
		var target = jQuery(this).data('scroll');

		jQuery('html, body').animate({
			scrollTop: jQuery(target).offset().top - 129
		}, 300);
	});


	jQuery('.flexi__accordions__title').click(function () {
		jQuery(this).parent().toggleClass('open');
	});

	jQuery('.woocommerce-billing-fields #billing-different').change(function () {
		jQuery('.woocommerce-billing-fields .billing-hidden').toggleClass('hidden');
	});

	jQuery('.shipping_address input').on('change input', function () {

		var data = jQuery(this).val(); 
		var shippingId = jQuery(this).attr('name');
		var billingId = shippingId.replace('shipping_', 'billing_');

		jQuery('body').find('.billing-hidden input#' + billingId).val(data);

	});

	jQuery('.shipping_address select#shipping_country').on('change', function () {
		var data = jQuery(this).val();
		var shippingId = jQuery(this).attr('name');
		var billingId = shippingId.replace('shipping_', 'billing_');

		jQuery('body').find('.billing-hidden select#' + billingId + ' option:selected').removeAttr('selected');
		jQuery('body').find('.billing-hidden select#' + billingId + ' option[value="' + data + '"]').attr('selected', 'selected');

		jQuery('select#' + billingId).select2();

	});

	jQuery('body').on('click', '.quant-wrap .quant-inc', function() {
		var el = jQuery(this).parent().find('.qty');
		var old = el.val();
		var old = parseFloat(old) + 1;


		if (jQuery('body').hasClass('single-product')){
			jQuery('.quant-wrap .qty').val(old);
		} else {
			jQuery(this).parent().find('.qty').val(old);
		}

		jQuery('body').find('.button.update').removeAttr('disabled').trigger('click');
	});

	jQuery('body').on('click', '.quant-wrap .quant-dec', function() {
		var el = jQuery(this).parent().find('.qty');
		var old = el.val();
		var old = parseFloat(old) - 1;
		if (old > 0){
			if (jQuery('body').hasClass('single-product')){
				jQuery('.quant-wrap .qty').val(old);
			} else {
				jQuery(this).parent().find('.qty').val(old);
			}
			jQuery('body').find('.button.update').removeAttr('disabled').trigger('click');
		}
	});

	jQuery('body').on('blur', '.quant-wrap input', function() {
		jQuery('body').find('.button.update').removeAttr('disabled').trigger('click');
	});

	// Checkout

	if (jQuery('body').hasClass('woocommerce-checkout')) {

		check_cart_item_errors();

		jQuery(document.body).on('updated_checkout', function () {
			check_cart_item_errors();
			update_delivery_options();
			toggle_local_delivery();
		});

		jQuery(document.body).on('checkout_error', function () {
			console.log('.on(checkout_error) has been run');
			var error_count = jQuery('.woocommerce-error li').length;

			if(jQuery('select#delivery_conf').length > 0 && jQuery('select#delivery_conf').val() == '') {
				error_count++;
			}

			if (error_count == 1) { // Validation Passed (Just the Fake Error I Created Exists)
				var error_text = jQuery('.woocommerce-error li')[0].innerText;
				if (error_text == 'custom_notice') {
					jQuery('.woocommerce-error').remove();

					var check_local = jQuery('#check_local').val();

					console.log('check_local', check_local);

					// Change Nav step
					jQuery('.checkout-nav li').removeClass('checkout-nav--active');
					jQuery('.checkout-nav li:nth-child(3)').addClass('checkout-nav--active');

					jQuery('.woocommerce-checkout__panel').removeClass('checkout_step--active');

					if (check_local == 'true') {
						jQuery('.checkout_step--local').addClass('checkout_step--active');
					} else {
						jQuery('.checkout_step--delivery').addClass('checkout_step--active');
					}

				}

			} else { // Validation Failed (Real Errors Exists, Remove the Fake One)
				jQuery('.woocommerce-error li').each(function(){
					var error_text = jQuery(this)[0].innerText;
					if (error_text == 'custom_notice'){
						jQuery(this).css('display', 'none');
					}
				});
			}
		});

		// jQuery('#shipping_postcode').on('input', debounce(update_shipping, 500));
		// function update_shipping() {
		// 	jQuery('body').trigger('update_checkout', { update_shipping_method: true });
		// }

		jQuery('body').on('click', '#place_order', function(e) {
			if (jQuery('#confirm-order-flag').length == 0) {
				jQuery('form.checkout').append('<input type="hidden" id="confirm-order-flag" name="confirm-order-flag" value="1">');
			}
		});

		jQuery('.ps_checkout').click(function() {
			checkout();
		});
	}

	function toggle_local_delivery() {
		var check_local = jQuery('#check_local').val();

		if (check_local) {
			var test = jQuery('.woocommerce-shipping-methods__item').data('checked', true);
			var cost = test.data('cost');

			if (cost !== 'Free') {

				jQuery('.ps_local_delivery__info--paid .basket_shipping__price').text(cost);

				jQuery('.ps_local_delivery__info--free').addClass('ps_local_delivery__info--hidden');
				jQuery('.ps_local_delivery__info--paid').removeClass('ps_local_delivery__info--hidden');

			}
		}
	}

	function check_cart_item_errors() {
		if (jQuery('.cart_item--error').length > 0) {
			if (jQuery('#cart-item-error').length == 0) {
				jQuery('form.checkout').append('<input type="hidden" id="cart-item-error" name="cart-item-error" value="1">');
			}
		} else {
			jQuery('#cart-item-error').val('');
		}
	}

	function checkout() {
		console.log('checkout() function has been run');
		jQuery('#confirm-order-flag').val('');
		jQuery('#place_order').trigger('click');
	}

	function update_delivery_options() {
		var target = jQuery('#nationwide_delivery_options');
		var methods = jQuery('.ps_delivery__input .ps_delivery__option');

		if (methods.length > 0) {
			// if the shipping methods have changed we need to empty the existing ones
			target.empty();
		}

		// This moves the shipping methods into our nationwide delivery step
		target.append(methods);

		jQuery('.ps_delivery__option input').on('change', function(e) {
			var delivery_option = jQuery(this).data('delivery_option');
			jQuery('input#' + delivery_option).trigger('click');
		});
	}

});

window.onscroll = function() {stickyHeader()};

var header = document.getElementById("head");
var sticky = header.offsetTop;

function stickyHeader() {
	if (window.pageYOffset > sticky) {
		header.classList.add("sticky");
	} else {
		header.classList.remove("sticky");
	}
}
stickyHeader();
